<template>
  <div class="page-content">
    <div class="page-banner program_banner">
      <div class="page-banner-content">
      <p><span class="pc-browser">VALSE&nbsp;&nbsp;2026&nbsp;&nbsp;</span>APR</p>
      </div>
    </div>
    <div class="main-container">
      <div class="content-item-grp">
        <div class="content-item" v-show="false">
          <div class="item-title">
            <span class="item-title-content">APR</span>
          </div>
          <div class="item-content">
            <p class="content-null-info">敬请期待......</p>
          </div>
        </div>
        <div class="content-item" v-show="true">
          <div class="item-title">
            <span class="item-title-content">APR讲者<br/><span class="item-title-label">（按报告顺序排列）</span></span>
          </div>
          <div class="item-content">
            <div class="speaker-list">
              <div class="speaker-item" v-for="item in speakers.aprspeakers">
                <div class="speaker-image" :style="{'background-image':'url('+item.image+')'}">
                  <!-- <img :src="item.image"/> -->
                </div>
                <div class="speaker-name">{{item.name}}</div>
                <div class="speaker-org">{{item.organization}}</div>
              </div>
            </div>

          </div>
        </div>
        <div class="content-item"  v-show="false">
          <div class="item-title">
            <span class="item-title-content">
              APR报告
            </span>
          </div>
          <div class="item-content">
              <div class="apr-report-list">
                <div class="apr-report-item">
                  <div class="apr-report-speaker">讲者：彭宇新（北京大学）</div>
                  <div class="apr-report-title">题目：细粒度多模态大模型</div>
                </div>
                <div class="apr-report-item">
                  <div class="apr-report-speaker">讲者：欧阳万里 (深圳河套学院、上海人工智能实验室)</div>
                  <div class="apr-report-title">题目：人工智能助力科学发现</div>
                </div>
                <div class="apr-report-item">
                  <div class="apr-report-speaker">讲者：戴国浩 (上海交通大学)</div>
                  <div class="apr-report-title">题目：大模型高效计算与推理</div>
                </div>
                <div class="apr-report-item">
                  <div class="apr-report-speaker">讲者：郝建业 (天津大学)</div>
                  <div class="apr-report-title">题目：基于大语言模型的智能体</div>
                </div>
                <div class="apr-report-item">
                  <div class="apr-report-speaker">讲者：高林 (中科院计算所)</div>
                  <div class="apr-report-title">题目：以人为中心的视觉内容生成</div>
                </div>
                <div class="apr-report-item">
                  <div class="apr-report-speaker">讲者：秦杰 (南京航空航天大学)</div>
                  <div class="apr-report-title">题目：开放世界目标检测</div>
                </div>
                <div class="apr-report-item">
                  <div class="apr-report-speaker">讲者：张正 (哈尔滨工业大学（深圳）)</div>
                  <div class="apr-report-title">题目：端侧轻量化大模型</div>
                </div>
                <div class="apr-report-item">
                  <div class="apr-report-speaker">讲者：韩波 (香港浸会大学)</div>
                  <div class="apr-report-title">题目：迈向可信大模型：学习，推理和泛化</div>
                </div>
                <div class="apr-report-item">
                  <div class="apr-report-speaker">讲者：邓磊 (清华大学)</div>
                  <div class="apr-report-title">题目：脉冲神经网络</div>
                </div>
                <div class="apr-report-item">
                  <div class="apr-report-speaker">讲者：崔兆鹏 (浙江大学)</div>
                  <div class="apr-report-title">题目：物理驱动的空间智能</div>
                </div>
                <div class="apr-report-item">
                  <div class="apr-report-speaker">讲者：杨学 (上海交通大学)</div>
                  <div class="apr-report-title">题目：有向目标检测</div>
                </div>
                <div class="apr-report-item">
                  <div class="apr-report-speaker">讲者：傅朝友 (南京大学)</div>
                  <div class="apr-report-title">题目：Omni大模型</div>
                </div>
                <div class="apr-report-item">
                  <div class="apr-report-speaker">讲者：马月昕 (上海科技大学)</div>
                  <div class="apr-report-title">题目：开放世界具身智能学习与交互</div>
                </div>
              </div>
          </div>
        </div>

        <div class="content-item"  v-show="true">
          <div class="item-title">
            <span class="item-title-content">
              <!-- 讲者介绍 -->
              APR报告
            </span>
          </div>
          <div class="item-content">
            <!-- <div class="tutorial-item" v-for="item in speakers.aprspeakers"> -->
              <!-- <div class="tutorial-item-images" :style="{'background-image':'url('+item.image+')'}"></div> -->
              <!-- <p><span class="report-title"><b>{{item.reportTitle}}（{{item.name}}）</b></span></p> -->

            <!-- </div> -->
            <div class="workshop-speaker-item" v-for="speaker in speakers.aprspeakers">
                <div class="speaker-item-images" :style="{'background-image':'url('+speaker.image+')'}"></div>
                <div class="speaker-item-intro">
                  <div class="item-name">{{speaker.name}}</div>
                  <div class="item-name">{{speaker.organization}}</div>
                  {{speaker.resume}}
                </div>
                <div class="report-item-contain">
                  <div class="report-title-contain">
                    <span class="report-title-label pc-browser">报告题目：</span>
                    <span class="report-title">{{speaker.reportTitle}}</span>
                  </div>

                  <div class="report-abstract" v-html="speaker.reportAbstract">
                  </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <p>© VALSE 2026 All rights reserved</p>
      <!--<img src="../../static/images/other-footer-bg.png"/>-->
    </div>
  </div>
</template>

<script>
    export default {
        name: "Speaker",
      data(){
          return {
            speakers:this.$dicts.speakers,
          }
      }
    }
</script>

<style scoped>
  .footer{
    /* position: fixed; */
    bottom: 0;
  }
  .program_banner{
    background-image: url("../../static/images/sub_banner/07.jpg");
  }
  .program_banner p{
    /*color: white;*/
  }
  .item-title-label{
    font-size: 12px;
    color: #2c3e50;
    padding-top: -10px;
  }
  .speaker-list{
    display: flex;
    justify-content: flex-start;
    flex-wrap:wrap;
  }
  .speaker-list .speaker-item{
    width: 160px;
    height: 220px;
  }
  .speaker-list .speaker-image{

    width: 120px;
    height: 120px;
    margin: 12px auto;
    background-size: cover;
    background-repeat: no-repeat;
    /*background-position: center;*/
    border-radius: 30px;
  }
  .speaker-list .speaker-image img{
    max-width: 100px;
    /*max-height: 100px;*/
    vertical-align: middle;
    border-radius: 30%;
  }
  .speaker-list .speaker-name{
    color: #0053a1;
    font-weight: 500;
  }

  .workshop-speaker-item{
    margin-bottom: 32px;
    background-color: #efefef;
    padding: 8px;
    border-radius: 10px;
    min-height: 200px;
  }
  .workshop-speaker-item .speaker-item-images{
    width: 160px;
    height: 160px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    border-radius: 80px;
    float:left;
    margin: 0 8px;
    /*clear: both;*/
  }
  .workshop-speaker-item .speaker-item-intro{
    text-align: justify;
    padding: 0 8px;
    padding-top: 40px;
    font-size: 16px;
  }
  .speaker-item-intro .item-name{
    margin-bottom: 8px;
    font-weight: 600;
  }
  .report-item-contain .report-title-contain{
    text-align: center;
    margin-top: 16px;
    font-size: 18px;
    color: #0053a1;
    font-weight: 700;

  }
  .report-abstract{
    text-indent: 2em;
    text-align: justify;
    padding: 0 8px;
  }
  .speakerandpanel-contain{
    margin-left: 50px;
    font-weight: 600;
  }

  .apr-report-list{
    text-align: left;
  }
  .apr-report-item{
    background: #fafafa;
    border: 1px solid #ebeef5;
    border-radius: 8px;
    padding: 12px 14px;
    margin-bottom: 12px;
  }
  .apr-report-speaker{
    font-weight: 700;
    color: #303133;
    margin-bottom: 6px;
  }
  .apr-report-title{
    color: #0053a1;
    font-weight: 600;
  }



  @media screen  and (max-width: 800px){
    .program_banner{
      /*background-image: url("../../static/images/speaker_mobile_banner.jpg");*/
      background-size: cover;
      /*background-position: right;*/
    }
  }
  @media screen  and (max-width: 710px){
    .speaker-list{
      justify-content: center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/APR.vue